// extracted by mini-css-extract-plugin
module.exports = {"wt4tu36":"wt4tu36","b1btlj5u":"b1btlj5u"};